import { ReactNode } from 'react';
import Icon from './Icon';
import styles from './EmptyState.module.css';

export type EmptyStateProps = {
  icone: string;
  titulo: string;
  descricao?: string;
  acao?: ReactNode;
};

export default function EmptyState({ icone, titulo, descricao, acao }: EmptyStateProps) {
  return (
    <div className={styles.raiz}>
      <div className={styles.circulo}>
        <Icon nome={icone} tamanho={48} />
      </div>
      <div className={styles.titulo}>{titulo}</div>
      {descricao && <div className={styles.descricao}>{descricao}</div>}
      {acao && <div className={styles.acao}>{acao}</div>}
    </div>
  );
}
